import { RichText } from 'src/components/Common/@electron/RichText';
import Tooltip from 'src/components/Common/Tooltip';
import { GenerateReferralsResultsType } from '../../../api/generateReferralsResponse';
import ContractorCard, { ContractorCardPropsType } from '../ContractorCard';
import RecommendedContractorsCard from '../RecommendedContractorsCard';
import { TradeAllyResultCardDataType } from '../RecommendedContractorsCard/data';

type DisplayContractorCardsType = Pick<ContractorCardPropsType, 'sendContractorCardAnalytics'> & {
  results: GenerateReferralsResultsType;
  headerText: string;
  tooltipText: string;
  introText: string;
  categoryImg?: string;
  categoryHeader?: string;
  tradeAllyResultCardData: TradeAllyResultCardDataType;
  referralIdLabel: string;
  startOver: () => void;
  startOverButtonText?: string;
};

const DisplayContractorCards = ({
  results,
  headerText,
  tooltipText,
  introText,
  categoryImg,
  categoryHeader,
  tradeAllyResultCardData,
  referralIdLabel,
  startOver,
  startOverButtonText,
  sendContractorCardAnalytics,
}: DisplayContractorCardsType) => {
  const tradeAllies = results.tradeAllyList;
  const { referralId } = results;

  return (
    <>
      <h1 className="text-3xl text-center text-white max-w-lg mx-auto mb-36">{headerText}</h1>
      <div
        // design has asked for the following card display:
        // 2x1 - 1 result + RC card
        // 3x1 - 2 result + RC card
        // 2x2 - 3 result + RC card
        // 2x2 - 4 result
        className={`${
          tradeAllies.length === 3 ? 'max-w-[1440px]' : 'max-w-3xl'
        } bg-white md:px-16 py-56 m-auto relative`}
      >
        {categoryImg && (
          <img
            src={categoryImg}
            alt=""
            aria-hidden
            className="w-76 mx-auto mb-12
            "
          ></img>
        )}
        <h2 className="text-gray-darker text-2xl text-center mb-32">{categoryHeader}</h2>
        <div className="border border-gray-light rounded-md bg-teal-lighter py-12 text-teal-darker text-center m-auto max-w-[1162px]">
          <div className="mx-auto">
            <span>
              {referralIdLabel} {referralId}{' '}
            </span>
            <Tooltip message={tooltipText} className="top-2" />
          </div>
        </div>
        <RichText
          className="max-w-[500px] text-center mt-32 mb-40 px-16 m-auto"
          value={introText}
        />
        <div className="flex flex-wrap justify-center">
          {tradeAllies.map((ally, index) => (
            <ContractorCard
              {...ally}
              key={index}
              sendContractorCardAnalytics={sendContractorCardAnalytics}
            />
          ))}
          <RecommendedContractorsCard results={tradeAllies} {...tradeAllyResultCardData} />
        </div>
        {startOverButtonText && (
          <div className="w-full text-center my-24">
            <button className="btn btn-primary w-auto" onClick={startOver}>
              {startOverButtonText}
            </button>
          </div>
        )}
      </div>
    </>
  );
};

export default DisplayContractorCards;
